const normalizeCountryCode = (countryCode) => countryCode?.toLowerCase?.() ?? "";

const getCountryList = (countryListResponse) => {
  if (Array.isArray(countryListResponse)) {
    return countryListResponse;
  }

  return countryListResponse?.data?.data ?? [];
};

export const resolveVendorDetails = ({ billingCountry, salesOrgId, currencyCode, inputCountry, countryListResponse }) => {
  const normalizedInputCountry = normalizeCountryCode(inputCountry);

  if (!normalizedInputCountry) {
    return {
      vendorCurrencyCode: null,
      vendorSalesOrg: null,
    };
  }

  if (normalizeCountryCode(billingCountry) === normalizedInputCountry) {
    return {
      vendorCurrencyCode: currencyCode || null,
      vendorSalesOrg: salesOrgId || null,
    };
  }

  const matchedCountry = getCountryList(countryListResponse).find((country) => normalizeCountryCode(country?.code) === normalizedInputCountry);

  return {
    vendorCurrencyCode: matchedCountry?.vendorCurrencyCode || "USD",
    vendorSalesOrg: matchedCountry?.vendorSalesOrg || "9001",
  };
};
